import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { EpdkIconLabelComponent } from './icon-label.component';

@NgModule({
  imports: [CommonModule, RouterModule],
  declarations: [EpdkIconLabelComponent],
  exports: [EpdkIconLabelComponent]
})
export class EpdkIconLabelModule { }